interface Option {
  value: string | number;
  label: string;
}
interface Props {
  label: string;
  value: string | number;
  options: Option[];
  onChange: (v: string | number) => void;
  disabled?: boolean;
}

export function SegmentedField({ label, value, options, onChange, disabled }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-[12px] font-medium text-[var(--text-secondary)]">{label}</span>
      <div className="flex gap-1.5 p-1 rounded-xl bg-[var(--bg-sunken)]">
        {options.map((opt) => {
          const active = opt.value === value;
          return (
            <button
              key={String(opt.value)}
              type="button"
              disabled={disabled}
              aria-pressed={active}
              onClick={() => onChange(opt.value)}
              className={[
                'flex-1 h-10 rounded-lg text-[13px] font-bold transition-all disabled:opacity-40',
                active
                  ? 'bg-[var(--primary)] text-[var(--primary-on)] shadow-[0_4px_14px_var(--primary-glow)]'
                  : 'text-[var(--text-secondary)] hover:bg-[var(--bg-elevated)] hover:text-[var(--text-primary)]',
              ].join(' ')}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
